import collection from '../helpers/collection'
import loading from '../helpers/loading'

import actions from './actions'

export default {
  namespaced: true,
  state: {
    ...loading.state,
    ...collection.state,
    scopes: {
      public: [],
      promotion: [],
      private: []
    }
  },
  getters: {
    ...loading.getters,
    ...collection.getters,
    scopes: (state, getter) => Object.keys(state.scopes),
    offers: (state, getter) => Object.keys(state.scopes)
      .filter(x => getter.categories.indexOf(x) < 0),
    categories: (state, getter, rootState, rootGetters) => {
      const platform = rootGetters['skiliko/session/currentPlatform']
      if (!platform) { return [] }
      if (!platform.settings.custom_offers) { return [] }
      return platform.settings.custom_offers.split(',')
    },
    servicesByScope: (state, getters) => getters.scopes.reduce((accumulator, scope) => {
      accumulator[scope] = (state.scopes[scope] || []).map(id => getters.collection[id])
      return accumulator
    }, {})
  },
  mutations: {
    ...loading.mutations,
    ...collection.mutations,
    updateScope: (state, { scope, services }) => {
      state.scopes = {
        ...state.scopes,
        [scope]: services.map(service => service.id)
      }
    }
  },
  actions
}



// WEBPACK FOOTER //
// ./src/store/skiliko/services/index.js